import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CourseIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Course",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M22.18 2.23H7.13C4.3 2.23 2 4.53 2 7.36v17.11c0 2.83 2.3 5.13 5.13 5.13h15.04c.94 0 1.71-.77 1.71-1.71 0-.12-.01-.24-.03-.34-.18-.79-.88-1.37-1.71-1.37H7.13c-.94 0-1.71-.77-1.71-1.71 0-.12.01-.24.03-.34.18-.79.88-1.37 1.71-1.37h15.01c.94 0 1.71-.77 1.71-1.71V3.94c0-.94-.77-1.71-1.71-1.71ZM26.47 7.48H30v18.94h-3.53zM28.88 2.23h-1.3c-.62 0-1.12.5-1.12 1.12v2.54h3.53V3.35c0-.62-.5-1.12-1.12-1.12ZM27.59 29.37c.39.64 1.08.43 1.31 0l1.1-1.94h-3.53c.02.07.74 1.34 1.12 1.95Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M20.46 28H14c-.55 0-1-.45-1-1v-6.46c0-.27.11-.52.29-.71l7.54-7.54a1 1 0 0 1 .71-.29c.27 0 .52.11.71.29l6.46 6.46c.39.39.39 1.02 0 1.41l-7.54 7.54a1 1 0 0 1-.71.29ZM15 26h5.05l6.54-6.54-5.05-5.05L15 20.95z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25 23.46c-.26 0-.51-.1-.71-.29l-6.46-6.46a.996.996 0 1 1 1.41-1.41l6.46 6.46a.996.996 0 0 1-.71 1.7ZM22 10H8c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10 28H8c-2.76 0-5-2.24-5-5V9c0-2.76 2.24-5 5-5h14c.55 0 1 .45 1 1s-.45 1-1 1H8C6.35 6 5 7.35 5 9v14c0 1.65 1.35 3 3 3h2c.55 0 1 .45 1 1s-.45 1-1 1"
      })]
    })
  }));
};